<template>
  <el-tooltip
    effect="dark"
    content="图片收藏夹"
    placement="bottom">
    <!-- <el-button class="d2-mr btn-text can-hover" type="text" @click="openImageFavorite">
      <d2-icon name="compress"/>
    </el-button> -->
    <i class="el-icon-star-off d2-mr btn-text can-hover" style="font-size: 20px" @click="openImageFavorite"></i>
  </el-tooltip>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  computed: {
    // ...mapState('d2admin/fullscreen', [
    //   'active'
    // ])
  },
  methods: {
    // ...mapActions('d2admin/fullscreen', [
    //   'toggle'
    // ]),
    openImageFavorite(){
      this.$router.push({
        path: "system/sysImageFavorite/index",
        name: "system-sysImageFavorite",
      });
    }

  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-imagefavorite/index.vue"
}
</vue-filename-injector>
